"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const camelcaseKeys = require("camelcase-keys");
class Country {
    constructor(response) {
        const camelcaseResponse = camelcaseKeys(response, {
            deep: true,
            exclude: [/\-/],
        });
        this.continent = camelcaseResponse.continent || undefined;
        this.country = camelcaseResponse.country || undefined;
        this.maxmind = camelcaseResponse.maxmind || undefined;
        this.registeredCountry =
            this.setBooleanRegisteredCountry(camelcaseResponse.registeredCountry) ||
                undefined;
        this.representedCountry = camelcaseResponse.representedCountry || undefined;
        this.traits = this.setBooleanTraits(camelcaseResponse.traits || {});
    }
    setBooleanTraits(traits) {
        const booleanTraits = [
            'isAnonymous',
            'isAnonymousProxy',
            'isAnonymousVpn',
            'isHostingProvider',
            'isLegitimateProxy',
            'isPublicProxy',
            'isResidentialProxy',
            'isSatelliteProvider',
            'isTorExitNode',
        ];
        booleanTraits.forEach((trait) => {
            traits[trait] = !!traits[trait];
        });
        return traits;
    }
    setBooleanRegisteredCountry(country) {
        if (country) {
            country.isInEuropeanUnion = !!country.isInEuropeanUnion;
        }
        return country;
    }
}
exports.default = Country;
